import GearSVG from '../../assets/svg/gear_1.svg';
import React from 'react';

export const UserXHeading = props => {
    return(
        <div className="heading">userX engineering</div>
    );
};

export const Gear = props => {
    return(
        <div
            className={props.className}
        >
            <img src={GearSVG} />
        </div>
    );
};


// WEBPACK FOOTER //
// ./src/components/presentation/index.js